import ValidationResult from './ValidationResult';

export default class SpreedlyValidationException extends Error {

    constructor(public readonly validationResult: ValidationResult[]) {
        super('There are some Spreedly validation errors from payment tokenization');
    }
}
